(ns io.daskul.webapp.views.detail-slots
  "Slot registry for the generic detail page (F-057).

   Products register slot components per aggregate, re-frame style
   (global, at boot, alongside configure!):

     (detail-slots/register! :lead {:main/before trial-session-card})

   The generic edit page renders each registered component at its band;
   positions are owned by the page design, never per-aggregate config.
   A slot component receives one ctx map ({:aggregate :record :schema
   :config :form :fsm :refetch!}) and may return nil to collapse its
   band. Slot output is rendered raw — a slot owns its own vertical
   spacing (:mb \"md\" above the form, :mt \"md\" below it).

   No React/UI imports here so the registry stays node-testable.")

(def slot-keys
  "Bands the generic edit page renders (F-057):
   :page/alerts — full content width, below the title, above both columns
   :main/before — main column, directly above the form card
   :main/after  — main column, directly below the form card"
  #{:page/alerts :main/before :main/after})

(defonce ^:private registry (atom {}))

(defn register!
  "Register detail-page slot components for an aggregate.
   slots is {slot-key component}; keys outside slot-keys warn (likely a
   typo) but are stored. Merges per slot key — later registrations win
   per key, so hot reloads and incremental adoption are idempotent.
   Components must be defui (a raw fn renders but gets nil props — $
   only threads the ctx map through a defui boundary)."
  [agg-key slots]
  (doseq [k (keys slots)]
    (when-not (contains? slot-keys k)
      (js/console.warn "detail-slots: unknown slot key" (str k)
                       "registered for" (str agg-key)
                       "— expected one of" (str slot-keys))))
  (swap! registry update agg-key merge slots)
  nil)

(defn slot
  "The component registered for agg-key's slot-key, or nil."
  [agg-key slot-key]
  (get-in @registry [agg-key slot-key]))

(defn registered
  "Snapshot of the whole registry ({agg-key {slot-key component}}).
   For inspection at the REPL/devtools."
  []
  @registry)
